// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import DashboardSvg from '@rsuite/icon-font/lib/application/Dashboard';
var Dashboard = createSvgIcon({
  as: DashboardSvg,
  ariaLabel: 'dashboard',
  category: 'application',
  displayName: 'Dashboard'
});
export default Dashboard;